<template>
  <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
            @click="sortBy(column.key)"
            class="sortable"
          >
            <span class="sort-item">
            {{ column.label }}
            <SortIcon class="sort-icon" v-if="sortField === column.key" :order="sortOrder"/>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="calculator in sortedCalculators"
          :key="calculator.id"
          class="table-row"
        >
          <td>{{ calculator.destination_city }}</td>
          <td>{{ calculator.departure_city }}</td>
          <td>{{ calculator.client_price_without_nds }}</td>
          <td>{{ calculator.client_price_with_nds }}</td>
          <!-- <td>{{ formatDate(calculator.load_date) }}</td> -->
          <!-- <td>{{ formatDate(calculator.upload_date) }}</td> -->
          <td>{{ formatPrice(calculator.cost_to_carrier_without_nds) }}</td>
          <td>{{ formatPrice(calculator.cost_to_carrier_with_nds) }}</td>
          <td>
            <span :class="getStatusClass(calculator.status)">
              {{ calculator.status }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import SortIcon from "@/pages/trade/components/SortIcon.vue";

export default {
  components: { SortIcon },
  setup() {
    const store = useStore();
    const columns = [
      { label: "Город назначения", key: "destination_city" },
      { label: "Город отправления", key: "departure_city" },
      // { label: "Дата загрузки", key: "load_date" },
      // { label: "Дата выгрузки", key: "upload_date" },
      { label: "Цена клиента (без НДС)", key: "client_price_without_nds" },
      { label: "Цена клиента (с НДС)", key: "client_price_with_nds" },
      { label: "Стоимость перевозчика (без НДС)", key: "cost_to_carrier_without_nds" },
      { label: "Стоимость перевозчика (с НДС)", key: "cost_to_carrier_with_nds" },
      { label: "Статус", key: "status" },
    ];

    const formatDate = (date) => {
      return new Date(date).toLocaleDateString("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    };

    const formatPrice = (price) => {
      return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "RUB" }).format(price);
    };

    const sortedCalculators = computed(() => store.getters["trade/sortedCalculators"]);
    const sortField = computed(() => store.state.trade.sortBy);
    const sortOrder = computed(() => store.state.trade.sortOrder);

    const sortBy = (field) => {
      const order = sortField.value === field && sortOrder.value === "asc" ? "desc" : "asc";
      store.dispatch("trade/sortCalculators", { field, order });
    };



    const getStatusClass = (status) => {
      return status === "Активен"
        ? "status-active"
        : status === "Неактивен"
        ? "status-inactive"
        : "status-default";
    };

    return {
      columns,
      sortedCalculators,
      sortField,
      sortOrder,
      sortBy,
      getStatusClass,
      formatDate,
      formatPrice,
    };
  },
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.custom-table th,
.custom-table td {
  border-bottom: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.custom-table thead {
  background-color: #f3f4f6;
}

.custom-table th {
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}

.custom-table th.sortable:hover {
  background-color: #e5e7eb;
}

.table-row:hover {
  background-color: #f9fafb;
}

.status-active {
  color: #10b981;
  font-weight: bold;
}

.status-inactive {
  color: #ef4444;
  font-weight: bold;
}

.status-default {
  color: #6b7280;
}

.sort-item{
  display: flex;
  justify-content: space-around;
}


</style>
